import React from 'react';

// Importa componentes necesarios
import PageTitle from '../components/pagetitle';
import CTA from '../components/cta';
import Section from '../components/section';
import Project from '../components/project/project_v3';
import Project2 from '../components/project/project_v2';
import dataSolution from '../assets/fake-data/data-solution';

// Importa datos necesarios
import { stepsRubros, steps, presentation, cursso, trabajosEspaciosConfinados, simuladorRockBraker, inspeccionCAEX } from '../assets/fake-data/data-simulator';

function Simulators(props) {
    return (
        <div className='inner-page'>
            {/* Título de la página */}
            <PageTitle title='Simuladores' />

            {/* Sección de participación en eventos */}
            <Section data={presentation} />

            {/* Sección de rubros */}
            <Project data={stepsRubros} title={'Creamos el mundo virtual que necesitas'} title_2={''} />

            {/* Sección de propuesta de valor */}
            <Section data={cursso} />

            {/* Sección de contenido e-learning */}
            <Project data={steps} title={'Accede a nuestro contenido'} title_2={'Desarrolla tu propio contenido'} />

            {/* Sección de trabajos en espacios confinados */}
            <Section data={trabajosEspaciosConfinados} />

            {/* Sección de simulador de equipo operación Rock Braker */}
            <Section data={simuladorRockBraker} />

            {/* Sección de inspección CAEX */}
            <Section data={inspeccionCAEX} />

            {/* Sección de soluciones */}
            <Project2 data={dataSolution} />

            {/* Llamada a la acción */}
            <CTA />
        </div>
    );
}

export default Simulators;